import React from 'react';
import { Box, Alert } from '@mui/material';
import { useQuery } from '@apollo/client';
import AppLayout from '../../components/Layout';
import DashboardGrid from './components/DashboardGrid';
import { DashboardHeader } from './components/DashboardHeader';
import { DashboardWidgetData } from './components/CustomChartWidget';
import { GET_DASHBOARD_WIDGETS } from './queries';
import useDashboards from './hooks/useDashboards';

const DAYS_COUNT = 14;

const Dashboard: React.FC = () => {
  const {
    dashboards,
    active,
    editMode,
    setEditMode,
    loading,
    error,
    handleCreate,
    handleRename,
    handleDelete,
    handleChangeLayout,
    handleSetSlot,
    handleSwitch,
  } = useDashboards();

  const { data: widgetsData } = useQuery(GET_DASHBOARD_WIDGETS);
  const widgets: DashboardWidgetData[] = widgetsData?.getDashboardWidgets || [];

  if (loading) return <AppLayout><Box sx={{ p: 4 }} /></AppLayout>;
  if (error) return <AppLayout><Alert severity="error">Failed to load dashboard: {error.message}</Alert></AppLayout>;

  const handleSlotChange = (slotIndex: number, widgetId: string | null) => {
    if (!active) return;
    handleSetSlot(active.id, slotIndex, widgetId);
  };

  return (
    <AppLayout>
      <DashboardHeader
        dashboards={dashboards}
        active={active}
        editMode={editMode}
        setEditMode={setEditMode}
        onCreate={handleCreate}
        onRename={handleRename}
        onDelete={handleDelete}
        onChangeLayout={handleChangeLayout}
        onSwitch={handleSwitch}
      />

      <DashboardGrid
        dashboard={active}
        widgets={widgets}
        editMode={editMode}
        daysCount={DAYS_COUNT}
        onSetSlot={handleSlotChange}
      />
    </AppLayout>
  );
};

export default Dashboard;
